<script>
import Layout from "../../layouts/main";
import Banner from "@/components/banner.vue"

export default ({
  name: "shops-map",

  components: {
    Layout, Banner
  },

    data() {
        return{
            contactUs:{ firstName: '' , secondName: '' , mail: '' , message:''},
        }
    },
      
});


</script>

<template>
  <Layout>

    <Banner pageTitle='Nos Magasins' subtitle2="Plus qu'un simple lieu d'achat, une expérience unique" subtitle1="Découvrez nos emplacements et venez vivre l'aventure" :imageBackGround="false" :small="true" ></Banner>


    <div class="row mt-4">
      <div class="col-12">
        <iframe height="600" src="https://www.google.com/maps/d/embed?mid=1gT9LxojI9g97mGuYfX0Q-zVThHA" width="100%"></iframe>   
      </div>
    </div>
 
  </Layout>
</template>
<style scoped>


</style>
